<template>
  <div class="api-key-action-table-cell">
    <div class='api-key-action-table-cell__btn' @click="deleteApiKey" @mouseenter='editMouseEnter'>
      <lottie-animation
        class='delete-animation'
        ref="deleteAnimation"
        :loop='true'
        :animationData="require('@/assets/icons/animations/delete.json')"
        @loopComplete="loopComplete"
      />
    </div>
  </div>
</template>

<script>
import LottieAnimation from 'lottie-web-vue';

export default {
  name: 'ApiKeyActionTableCell',
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
    clickEventName: {
      type: String,
      required: false,
      default: 'deleteApiKey',
    },
  },
  components: {
    LottieAnimation,
  },
  methods: {
    async deleteApiKey() {
      await this.$emit(this.clickEventName, this.item);
    },
    editMouseEnter() {
      this.$refs.deleteAnimation.play();
    },
    loopComplete() {
      this.$refs.deleteAnimation.pause();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "src/assets/styles/variables";

.api-key-action-table-cell {
  align-items: center;
  justify-content: flex-end;
  display: var(--displayactioncell) !important;

  &__btn {
    z-index: 10;
    align-items: center;
    background-color: $action-button-background-color;
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    height: 32px;
    justify-content: center;
    width: 32px;
    min-width: 32px;
    min-height: 32px;
    color: $default-fill-color !important;
    &:hover {
      cursor: pointer;
      border: $action-button-hover-border;
      background-color: $action-button-hover-background-color !important;
    }
    &:active{
      border: $action-button-active-border;
      background-color: $action-button-hover-background-color !important;
    }
    .delete-animation{
      height: 30px;
      margin-top: -5px;
    }
  }
}
</style>
